import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
import Zoom from 'react-reveal/Zoom';
import { Fade } from "react-reveal";
import c from '../images/c.png'
import chat from "../images/chatapp.gif"
import ec from '../images/bewakoof.gif'
import ba from '../images/dunzo.gif'
import wa from '../images/dineout.gif'
import ci from '../images/onboarding.gif'
import { FaPlay, FaCode } from 'react-icons/fa';
import { Link } from 'react-router-dom'
import { HiArrowRight } from "react-icons/hi";

export default function Projects() {
    return (
        <div id="projects">
            <Container fluid className="certificate-section" id="about">
                <Container>
                    <Row>
                        <Col md={12} className="certificate-description d-flex justify-content-start">
                            <Zoom left cascade>
                                <h1 className='aboutme-heading'>
                                    Projects
                                </h1>
                            </Zoom>
                        </Col>
                        <Col md={12} className="mt-3">
                            <Row className='g-4'>
                                <Col md={6}>
                                    <Fade bottom>
                                        <div
                                            key={1}
                                            className='singleProject'
                                            style={{ backgroundColor: 'rgb(142 70 186 / 31%)',
                                            border: '1px solid' }}
                                        >
                                            <div className='projectContent'>
                                                <h2
                                                    id={'first'}
                                                    style={{ color: '#fbd9ad' }}
                                                >
                                                   bewkoof clone
                                                </h2>
                                                <img src={ec} alt={c} />
                                                <div className='project--showcaseBtn'>
                                                    <a
                                                        href={'https://bewkoof-github-io-aramanrajput.vercel.app/'}
                                                        target="_self"
                                                        rel='noreferrer'
                                                        className={'iconBtn'}
                                                        aria-labelledby={`hello`}
                                                    >
                                                        <FaPlay
                                                            id={`demo`}
                                                            className={'icon'}
                                                            aria-label='Demo'
                                                        />
                                                    </a>
                                                    <a
                                                        href={'https://github.com/aramanrajput/bewkoof.github.io'}
                                                        target="_self"
                                                        rel='noreferrer'
                                                        className={'iconBtn'}
                                                        aria-labelledby={`code`}
                                                    >
                                                        <FaCode
                                                            id={`code`}
                                                            className={'icon'}
                                                            aria-label='Code'
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <p
                                                className='project--desc'
                                                style={{
                                                    background: '#fbd9ad',
                                                    color: 'rgb(147 71 192)',
                                                    fontWeight:600
                                                }}
                                            >
                                                This website is a e-commerce platform website where user can buy any product here I have tried to add every feature I could here seller can also sell product and can add product.
                                            </p>
                                            <div
                                                className='project--lang'
                                                style={{
                                                    background: '#fbd9ad',
                                                    color: '#b061df',
                                                    fontWeight:600
                                                }}
                                            >
                                                HTML, CSS, JavaScript
                                            </div>
                                        </div>
                                    </Fade>
                                </Col>
                                <Col md={6}>
                                    <Fade bottom>
                                        <div
                                            key={1}
                                            className='singleProject'
                                            style={{ backgroundColor: 'rgb(142 70 186 / 31%)',
                                            border: '1px solid' }}
                                        >
                                            <div className='projectContent'>
                                                <h2
                                                    id={'first'}
                                                    style={{ color: '#fbd9ad' }}
                                                >
                                                   dunzo clone
                                                </h2>
                                                <img src={ba} alt={c} />
                                                <div className='project--showcaseBtn'>
                                                    <a
                                                        href={'https://masai-dunzo.netlify.app/'}
                                                        target="_self"
                                                        rel='noreferrer'
                                                        className={'iconBtn'}
                                                        aria-labelledby={`hello`}
                                                    >
                                                        <FaPlay
                                                            id={`demo`}
                                                            className={'icon'}
                                                            aria-label='Demo'
                                                        />
                                                    </a>
                                                    <a
                                                        href={'https://github.com/jaidev3/FW12_Dunzo_Project-Back-End'}
                                                        target="_self"
                                                        rel='noreferrer'
                                                        className={'iconBtn'}
                                                        aria-labelledby={`code`}
                                                    >
                                                        <FaCode
                                                            id={`code`}
                                                            className={'icon'}
                                                            aria-label='Code'
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <p
                                                className='project--desc'
                                                style={{
                                                    background: '#fbd9ad',
                                                    color: '#b061df',
                                                    fontWeight:600
                                                }}
                                            >
                                          This is a clone of dunzo where user can purchase products
                                            </p>
                                            <div
                                                className='project--lang'
                                                style={{
                                                    background: '#fbd9ad',
                                                    color: '#b061df',
                                                    fontWeight:600
                                                }}
                                            >
                                               HTML, CSS, JS,Nodejs,Expressjs,MongoDb
                                            </div>
                                        </div>
                                    </Fade>
                                </Col>
                                <Col md={6}>
                                    <Fade bottom>
                                        <div
                                            key={1}
                                            className='singleProject'
                                            style={{ backgroundColor: 'rgb(142 70 186 / 31%)',
                                            border: '1px solid' }}
                                        >
                                            <div className='projectContent'>
                                                <h2
                                                    id={'first'}
                                                    style={{ color: '#fbd9ad' }}
                                                >
                                                    dineout clone
                                                </h2>
                                                <img src={wa} alt={c} />
                                                <div className='project--showcaseBtn'>
                                                    <a
                                                        href={'https://dineoutclone-gamma.vercel.app/'}
                                                        target="_self"
                                                        rel='noreferrer'
                                                        className={'iconBtn'}
                                                        aria-labelledby={`hello`}
                                                    >
                                                        <FaPlay
                                                            id={`demo`}
                                                            className={'icon'}
                                                            aria-label='Demo'
                                                        />
                                                    </a>
                                                    <a
                                                        href={'https://github.com/RajP62/Dineout'}
                                                        target='_blank'
                                                        rel='noreferrer'
                                                        className={'iconBtn'}
                                                        aria-labelledby={`code`}
                                                    >
                                                        <FaCode
                                                            id={`code`}
                                                            className={'icon'}
                                                            aria-label='Code'
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <p
                                                className='project--desc'
                                                style={{
                                                    background: '#fbd9ad',
                                                    color: '#b061df',
                                                    fontWeight:600
                                                }}
                                            >
                                                It’s my major project where I've used MERN stack to make an E-Commerce website along with backend integration and important functionalities.
                                            </p>
                                            <div
                                                className='project--lang'
                                                style={{
                                                    background: '#fbd9ad',
                                                    color: '#b061df',
                                                    fontWeight:600
                                                }}
                                            >
                                                ReactJS,Nodejs,Expressjs,Mongodb,MaterialUI
                                            </div>
                                        </div>
                                    </Fade>
                                </Col>
                                <Col ms={6}>
                                    <Fade bottom>
                                        <div
                                            key={1}
                                            className='singleProject'
                                            style={{ backgroundColor: 'rgb(142 70 186 / 31%)',
                                            border: '1px solid' }}
                                        >
                                            <div className='projectContent'>
                                                <h2
                                                    id={'first'}
                                                    style={{ color: '#fbd9ad' }}
                                                >
                                                    Chat Application
                                                </h2>
                                                <img src={chat} alt={c} />
                                                <div className='project--showcaseBtn'>
                                                    <a
                                                        href={'https://chatapp-gray-kappa.vercel.app'}
                                                        target="_self"
                                                        rel='noreferrer'
                                                        className={'iconBtn'}
                                                        aria-labelledby={`hello`}
                                                    >
                                                        <FaPlay
                                                            id={`demo`}
                                                            className={'icon'}
                                                            aria-label='Demo'
                                                        />
                                                    </a>
                                                    <a
                                                   
                                                        href={'https://github.com/aramanrajput/chat-app/tree/master'}
                                                        target="_self"
                                                        rel='noreferrer'
                                                        className={'iconBtn'}
                                                        aria-labelledby={`code`}
                                                    >
                                                        <FaCode
                                                            id={`code`}
                                                            className={'icon'}
                                                            aria-label='Code'
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <p
                                                className='project--desc'
                                                style={{
                                                    background: '#fbd9ad',
                                                    color: '#b061df',
                                                    fontWeight:600
                                                }}
                                            >
                                                This is a messaging chat application built using socket-io.Chatting website which lets users create private rooms dynamically and 
                                                it also shows all the users present in a room
                                            </p>
                                            <div
                                                className='project--lang'
                                                style={{
                                                    background: '#fbd9ad',
                                                    color: '#b061df',
                                                    fontWeight:600
                                                }}
                                            >
                                                React,Nodejs,Expressjs,Socket-io
                                            </div>
                                        </div>
                                    </Fade>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <div className="blog--viewAll">
                                <Link to="/projectspage">
                                    <button className='btn btn-primary'>
                                        View All
                                        <HiArrowRight className='viewArr'   />
                                    </button>
                                </Link>
                    </div>
                </Container>
            </Container>
        </div>
    )
}
